import React from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { ArrowLeft, ShieldCheck } from "lucide-react";
import RoleRegistrationForm from "./RoleRegistrationForm";
import "../../GisincidentManagement/ViewIncident/ViewIncident.css";

const CreateRole = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { state } = useLocation();
  const edit = state?.data;

  return (
    <div style={{ margin: "8px", fontFamily: "'Poppins', 'Segoe UI', sans-serif" }}>
      <style>{`@import url('https://fonts.googleapis.com/css2?family=Poppins:wght@500;600;700;800&display=swap');`}</style>
      <div className="incv-header-banner">
        <button type="button" className="incv-back-btn" onClick={() => navigate(-1)} aria-label="Back">
          <ArrowLeft size={16} />
        </button>
        <span className="incv-header-icon">
          <ShieldCheck size={14} color="#fff" />
        </span>
        <div>
          <div className="incv-header-title">{edit ? "Edit Role" : t("createrole_management_formheader")}</div>
          <div className="incv-header-subtitle">{edit ? "Update role and permission levels" : "Register a new role"}</div>
        </div>
      </div>
      <div style={{ marginTop: "10px", backgroundColor: "#fff", borderRadius: "10px", padding: "20px 16px" }}>
        <RoleRegistrationForm />
      </div>
    </div>
  );
};

export default CreateRole;
